import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";

// Self-hosted variable fonts (replaces Google Fonts CDN)
import "@fontsource-variable/golos-text";
import "@fontsource-variable/inter";
import "@fontsource-variable/jetbrains-mono";
import "@fontsource-variable/playfair-display";

// Force HTTPS redirect in production
if (
  typeof window !== "undefined" &&
  window.location.protocol === "http:" &&
  !window.location.hostname.includes("localhost") &&
  !window.location.hostname.includes("127.0.0.1")
) {
  window.location.href = window.location.href.replace("http:", "https:");
}

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
